/* eslint-disable */


/**
 * Create styles for `<LogoutPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<LogoutPage />` styles
 */
const logoutPageStyles = ({ theme }) => ({
  root: {},
});

export default logoutPageStyles;
